import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "./adminAxios";
import { toast } from "react-toastify";
import { FaUserShield, FaLock, FaEnvelope } from "react-icons/fa";

export default function SuperAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("All fields are required");

    try {
      setLoading(true);
      const res = await API.post("/super-admin/login", { email, password });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("superAdmin", JSON.stringify(res.data.superAdmin));
      toast.success("Superadmin Access Granted 🚀");
      navigate("/super-admin");
    } catch (err) {
      toast.error(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <FaUserShield color="#00f2ff" size={28} />
        </div>
        <h2 style={styles.title}>ROOT COMMAND</h2>
        <p style={styles.subtitle}>Superadmin Authentication Portal</p>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}><FaEnvelope /> EMAIL</label>
            <input 
              type="email" 
              placeholder="superadmin@store.com" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              style={styles.input} 
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}><FaLock /> PASSWORD</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              style={styles.input} 
            />
          </div>

          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? "AUTHENTICATING..." : "INITIALIZE ROOT SESSION"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#020617", fontFamily: "'Inter', sans-serif" },
  card: { background: "rgba(15, 23, 42, 0.7)", backdropFilter: "blur(16px)", padding: "40px", borderRadius: "24px", width: "100%", maxWidth: "420px", border: "1px solid rgba(255,255,255,0.08)", boxShadow: "0 25px 50px rgba(0,0,0,0.5)" },
  iconCircle: { width: "60px", height: "60px", background: "rgba(0, 242, 255, 0.1)", borderRadius: "18px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", border: "1px solid rgba(0, 242, 255, 0.2)" },
  title: { fontSize: "22px", fontWeight: "900", color: "#fff", textAlign: "center", margin: 0, letterSpacing: "1px" },
  subtitle: { color: "#94a3b8", fontSize: "13px", textAlign: "center", marginTop: "6px", marginBottom: "30px" },
  form: { display: "flex", flexDirection: "column", gap: "20px" },
  inputGroup: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { fontSize: "11px", fontWeight: "700", color: "#64748b", display: "flex", alignItems: "center", gap: "6px", letterSpacing: "1px" },
  input: { padding: "14px", background: "rgba(0,0,0,0.3)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "12px", color: "#fff", outline: "none", fontSize: "15px" },
  btn: { padding: "16px", background: "linear-gradient(135deg, #00f2ff 0%, #0284c7 100%)", color: "#0f172a", border: "none", borderRadius: "12px", fontWeight: "900", cursor: "pointer", fontSize: "14px", marginTop: "10px", letterSpacing: "1px" }
};